// extracted by mini-css-extract-plugin
export default {"AccessoryItem":"AccessoryItem__AccessoryItem___AEtU8","name":"AccessoryItem__name___hvcjH","price":"AccessoryItem__price___jyiBW","code":"AccessoryItem__code___G7mi3"};